var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-4",
      attrs: { "border-color-hex": "#FB7058", "has-toggle": false }
    },
    [
      _c("icon-view", {
        staticClass: "mt-2 ml-4 pl-3",
        attrs: {
          icon: "fas fa-user mb-1",
          "icon-background": "#fff",
          "icon-color": "#ff745c",
          "icon-size": "14px",
          title: "Búsqueda de Estudiante"
        }
      }),
      _c("validation-observer", { ref: "reinbursementRef" }, [
        _c("div", { staticClass: "row mt-3 ml-4" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-sm-12 mt-3 mt-md-0" },
            [
              _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required:
                      "El número SIE, Registro o Consulta es requerido.",
                    startsLikeTapRequestNumber:
                      "El número de consulta no es válido.",
                    studentSie: "El número de SIE no es válido."
                  },
                  rules: {
                    required: true,
                    startsLikeTapRequestNumber: _vm.startWithLetters,
                    studentSie: !_vm.startWithLetters
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            error: errors[0],
                            icon: "fa fa-search color-orange",
                            "label-class": "font-14",
                            "left-icon": "",
                            placeholder:
                              "Escriba número de sie, número de registro o número de consulta"
                          },
                          model: {
                            value: _vm.tapRequestNumber,
                            callback: function($$v) {
                              _vm.tapRequestNumber = $$v
                            },
                            expression: "tapRequestNumber"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c("action-button", {
                attrs: {
                  i: "fa fa-search",
                  text: "Buscar",
                  variant: "success px-4"
                },
                on: { click: _vm.handlerSearch }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 mt-4 d-flex justify-content-end" },
            [
              !_vm.showRequest
                ? _c("action-button", {
                    attrs: {
                      i: "fas fa-times-circle",
                      text: "Cerrar",
                      variant: "outline-danger  m-md-2 px-4"
                    },
                    on: { click: _vm.onCancel }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm.showRequest
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "row ml-2 mt-2 mb-3" },
                [
                  _c("icon-view", {
                    staticClass: "mt-2",
                    attrs: {
                      "has-border": false,
                      icon: "fas fa-info pb-1",
                      "icon-background": "#ff745c",
                      "icon-color": "#fff",
                      "icon-size": "14px",
                      title: "Información del Estudiante"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "row my-2 ml-2 mr-3 pl-4 pt-3 pb-4 bg-white border-radius--light request-reinbursement-custom-callout"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" Nombre del Estudiante: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _vm._v(" " + _vm._s(_vm.model.studentName) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" SIE: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _vm._v(" " + _vm._s(_vm.model.studentSie) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" Edad: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _vm._v(" " + _vm._s(_vm.model.studentAge) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" Número de Consulta: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _vm._v(" " + _vm._s(_vm.model.tapRequestNumber) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" SSN: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "mr-2" }, [
                            _vm._v(
                              " " + _vm._s(_vm.formatSsn(_vm.model.ssn)) + " "
                            )
                          ]),
                          _c("i", {
                            staticClass: "mt-1 cursor-pointer",
                            class: {
                              "fal fa-eye": _vm.showSSN,
                              "fal fa-eye-slash": !_vm.showSSN
                            },
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                _vm.showSSN = !_vm.showSSN
                              }
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 mt-3 mt-md-0" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-6 d-block font-14" },
                        [_vm._v(" Estatus: ")]
                      ),
                      _c("span", { staticClass: "font-16 color-black" }, [
                        _vm._v(" " + _vm._s(_vm.model.statusName) + " ")
                      ])
                    ]
                  )
                ]
              ),
              _c("div", { staticClass: "ml-2 mr-3 mt-4 pb-2 border-bottom" }),
              _vm.isDirectPayment
                ? _c(
                    "div",
                    { staticClass: "col-12 mt-4 d-flex justify-content-end" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-times-circle",
                          text: "Cerrar",
                          variant: "outline-danger  m-md-2 px-4"
                        },
                        on: { click: _vm.onCancel }
                      }),
                      _c("action-button", {
                        attrs: {
                          i: "fa fa-arrow-alt-circle-right",
                          text: "Continuar",
                          variant: "success m-md-2 px-4"
                        },
                        on: { click: _vm.onContinue }
                      })
                    ],
                    1
                  )
                : _c("validation-observer", { ref: "ssnRef" }, [
                    _c("div", { staticClass: "row pl-2 py-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-3 col-sm-12 mt-3 mt-md-0" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              "custom-messages": {
                                required:
                                  "El número de seguro social es requerido.",
                                ssn: "El número de seguro social no es válido."
                              },
                              rules: "required|ssn"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          errors: errors[0],
                                          label: "Número de Seguro Social:",
                                          "label-class": "font-14",
                                          "mask-type": "Personalssn",
                                          maxlength: "11",
                                          placeholder: "xxx-xx-xxxx"
                                        },
                                        model: {
                                          value: _vm.ssnNumber,
                                          callback: function($$v) {
                                            _vm.ssnNumber = $$v
                                          },
                                          expression: "ssnNumber"
                                        }
                                      }),
                                      errors[0]
                                        ? _c("error", {
                                            attrs: {
                                              message: errors[0],
                                              variant: "no-border mt-1"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2482403318
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-8 col-sm-12 mt-4 pr-4 d-flex align-items-start justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Cancelar",
                              variant: "outline-danger m-md-2 px-4"
                            },
                            on: { click: _vm.onCancel }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-arrow-alt-circle-right",
                              text: "Continuar",
                              variant: "success m-md-2 px-4"
                            },
                            on: { click: _vm.onContinue }
                          }),
                          _vm.sifdeRegistryDocument
                            ? _c("div", { staticClass: "ml-2 mt-3" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "color-green",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.downloadFile()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-download"
                                    }),
                                    _vm._v(
                                      " Descargar formulario de registro de SIFDE "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("custom-error", {
                            staticClass: "mr-3",
                            attrs: {
                              "is-alert-mode": "",
                              message:
                                "\n            Para comenzar con el proceso de solicitud de reembolso, es importante que se encuentre registrado en el Sistema de Información Financiera del Departamento de Educación (SIFDE).\n            "
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }